import Button from "../../../SharedComponents/Button";
import { BUTTON_VARIANT_TYPES } from "../../../../utils/constants";

import { CalendarIcon, ClockIcon, ExternalLinkIcon, PuzzleIcon, CheckIcon, EmojiSadIcon } from "@heroicons/react/solid";
import { useEffect, useState } from "react";
import { getAssessmentLaunchUrl } from "../../../../utils/api";
import { isMobile } from "react-device-detect";

function Assessment(props) {
    const { item: assessment } = props;

    const [expired, setExpired] = useState(false);
    const [launching, setLaunching] = useState(false);
    const [timeLimit, setTimeLimit] = useState("");

    const launchAssessment = async () => {
        setLaunching(true);
        try {
            /*'md': '768px' & isMobile returns true if device type is mobile or tablet */
            if (window.innerWidth <= 768 || isMobile) {
                // Open link directly
                window.location.replace(await getAssessmentLaunchUrl(assessment.orderIdentifier));
            } else {
                // Open link in a new tab
                window.open(await getAssessmentLaunchUrl(assessment.orderIdentifier), "_blank");
            }
        } catch (err) {
            alert("Failed to start the assessment, please try again or contact support.");
        }
        setLaunching(false);
    };

    useEffect(() => {
        setExpired(assessment.dueDate !== null && Date.now() >= new Date(assessment.dueDate));
        setTimeLimit(
            assessment.isTimed
                ? `${parseInt(assessment.timeLimitSecs / 60, 10)} minutes`
                : `${assessment.minTimeMins} - ${assessment.maxTimeMins} minutes`
        );
    }, [
        assessment.dueDate,
        assessment.isTimed,
        assessment.maxTimeMins,
        assessment.minTimeMins,
        assessment.timeLimitSecs,
    ]);

    return (
        <div className="bg-white shadow-sm w-full h-full rounded-lg grid grid-flow-row">
            <div className="p-4 grid grid-flow-row gap-5">
                <img className="h-5 col-span-3" src={assessment.logoUrl} alt="logo" />
                <div
                    className={
                        "font-medium text-" +
                        (expired && !assessment.isCompleted ? "red" : assessment.themeColour) +
                        "-600"
                    }
                >
                    {assessment.name}
                </div>
            </div>
            <div
                className={
                    "grid grid-flow-row gap-4 p-4 rounded-lg bg-gradient-to-r from-" +
                    (expired && !assessment.isCompleted ? "red" : assessment.themeColour) +
                    "-50"
                }
            >
                <div className="grid grid-flow-row gap-2 font-medium">
                    <div
                        className={
                            "flex items-center gap-2 text-sm text-" +
                            (expired && !assessment.isCompleted ? "red" : assessment.themeColour) +
                            "-600"
                        }
                    >
                        <ClockIcon className={"block h-4 w-4 ml-1"} />
                        {timeLimit + ","}
                        <span className={"underline"}>{assessment.timed ? "timed" : "untimed"}</span>
                    </div>
                    <div
                        className={
                            "flex items-center gap-2 text-sm text-" +
                            (expired && !assessment.isCompleted ? "red" : assessment.themeColour) +
                            "-600"
                        }
                    >
                        <PuzzleIcon className={"block h-4 w-4 ml-1"} />
                        {assessment.questionTypes}
                    </div>
                    <div
                        className={
                            "flex items-center gap-2 text-sm text-" +
                            (expired && !assessment.isCompleted ? "red" : assessment.themeColour) +
                            "-600"
                        }
                    >
                        <CalendarIcon className={"block h-4 w-4 ml-1"} />
                        {assessment.dueDate == null
                            ? "-"
                            : new Date(assessment.dueDate).toLocaleString([], { hour12: true })}
                    </div>
                </div>
                {assessment.isCompleted ? (
                    <div className={"flex items-center text-sm text-green-600 font-medium"}>
                        <CheckIcon className={"block h-4 w-4 mr-1"} />
                        You have completed this assessment
                    </div>
                ) : expired ? (
                    <div className={"flex items-center text-sm text-red-600 font-medium"}>
                        <ClockIcon className={"block h-4 w-4 mr-1"} />
                        This assessment has expired
                    </div>
                ) : assessment.orderIdentifier === null ? (
                    <div className={"flex items-center text-sm text-red-600 font-medium"}>
                        <EmojiSadIcon className={"block h-4 w-4 mr-1"} />
                        There was an error, please contact techsupport
                    </div>
                ) : (
                    <Button
                        onClick={launchAssessment}
                        colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                        text={"Start assessment"}
                        extraStyling={"w-full text-center justify-center bg-" + assessment.themeColour + "-600"}
                        icon={<ExternalLinkIcon className={"block h-4 w-4 ml-1"} />}
                        loading={launching}
                    />
                )}
            </div>
        </div>
    );
}

export default Assessment;
